module.exports = __webpack_public_path__ + "static/media/bgDefaultCoursesDay.83524de1.jpg";